/* eslint-disable */
// FIXME: enable linting
// all user-related interactions, including fiscal code updates
import * as Sentry from "@sentry/vue";
import userLogout from "~/helpers/userLogout"; // eslint-disable-line import/no-extraneous-dependencies
import User from "../../clients/user"; // eslint-disable-line import/no-extraneous-dependencies

const state = {
  user: { emails: [], schools: [] },
  localFiscalCode: "",
  userFiscalCode: "",
  isFCWrong: false,
  fiscalCodeError: false,
  localConfirmedData: true,
};

const getters = {
  user: moduleState => moduleState.user,
  fiscalCodeError: moduleState => moduleState.fiscalCodeError,
  localFiscalCode: moduleState => moduleState.localFiscalCode,
  userFiscalCode: moduleState => moduleState.userFiscalCode,
  isFCWrong: moduleState => moduleState.isFCWrong,
  fiscalCode: moduleState => moduleState.localFiscalCode,
  localConfirmedData: moduleState => moduleState.localConfirmedData,
};

const actions = {
  async fetchFiscalCode({ commit, rootState, getters }) {
    if (!getters.userFiscalCode) {
      try {
        const fc = await User.getFiscalCode(rootState.config);
        if (fc) {
          commit("setUserFiscalCode", fc);
          commit("setLocalFiscalCode", fc);
        }
      } catch (e) {
        Sentry.captureException(e);
        if (e.response && e.response.status === 401) {
          userLogout();
        }
      }
    }
  },
  setLocalFiscalCode({ commit }, fiscalCode) {
    /*
    this set the validated fiscal code when the blur event on the input field is fired
    to save the state, `storeFiscalCode` is required
    */
    commit("setLocalFiscalCode", fiscalCode);
  },
  async storeFCOnly({ commit, state, rootState }) {
    try {
      const fc = await User.setFiscalCode(rootState.config, state.localFiscalCode);
      if (fc) {
        commit("setUserFiscalCode", fc);
      }
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      commit("setFiscalCodeError", true);
    }
  },
  async storeFiscalCode({ commit, state, rootState }) {
    try {
      const fc = await User.setFiscalCode(rootState.config, state.localFiscalCode);
      if (fc) {
        commit("setUserFiscalCode", fc);
        commit("setOrderState", rootState.config.states.Laboratories);
        commit("setConfirmedData", true);
      }
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      commit("setFiscalCodeError", true);
    }
  },
  confirmData({ dispatch }) {
    dispatch("storeOrderConfirmedData", true);
  },
  resetConfirmationData({ commit, dispatch }) {
    commit("resetLocalConfirmedData", false);
    dispatch("storeOrderResetConfirmation", false);
  },
};

const mutations = {
  setFiscalCodeError: (oldState, fiscalCodeError) => (oldState.fiscalCodeError = fiscalCodeError),
  setUser: (oldState, user, userHeaderUpdate = true) => {
    oldState.user = user;
  },
  setFiscalCode: (oldState, cf) => (oldState.user.cf = cf),
  setLocalFiscalCode: (oldState, cf) => (oldState.localFiscalCode = cf),
  setUserFiscalCode: (oldState, cf) => (oldState.userFiscalCode = cf),
  setFCCheck: (oldState, FCCheck) => (oldState.isFCWrong = FCCheck),
  setConfirmedData: (oldState, confirmation) => (oldState.user.confirmed_data = confirmation),
  resetConfirmedData: (oldState, reset) => (oldState.user.confirmed_data = reset),
  resetLocalConfirmedData: (oldState, reset) => (oldState.localConfirmedData = reset),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
